import arraysDoOverlap from 'src/utils/arrayOperations/arraysOverlap';
// "Acting user" is the user from whose name we are seeing the screen and from whose name we're acting
const state = {
    actingUserId: null,
    userObj: null,
    roles: null,
    controlledActions: null
};
const getters = {
    getActingUser: (state) => {
        return state.userObj;
    },
    actingUserRoles: (state) => {
        return state.roles;
    },
    getActingUserControlledActions: (state) => {
        return state.controlledActions;
    },
    actingUserHasRole: (state) => (x) => {
        var _a;
        if (Array.isArray(x)) {
            const arrB = state.roles;
            if (!arrB)
                return false;
            return arraysDoOverlap(x, arrB);
        }
        else {
            return (_a = state.roles) === null || _a === void 0 ? void 0 : _a.includes(x);
        }
    },
    actingUserHasSingleRole: (state) => (x) => {
        const roles = state.roles;
        if (!roles || roles.length !== 1)
            return false;
        if (x && roles[0] !== x)
            return false;
        return true;
    },
    actingUserName: (state) => {
        return (state.userObj || {}).name;
    },
    actingUserHasControlledAction: (state) => (x) => {
        const ownActions = state.controlledActions;
        if (!ownActions)
            return false;
        if (!Array.isArray(ownActions))
            throw console.error('User own controlledActions must be an array');
        if (ownActions.length === 0)
            return false;
        if (Array.isArray(x)) {
            return x.includes(0) || arraysDoOverlap(x, ownActions);
        }
        else {
            return x === 0 || ownActions.includes(x);
        }
    }
};
const mutations = {
    SET_ACTING_USER_ID(state, value) {
        state.actingUserId = value;
    },
    SET_USER_OBJ(state, val) { state.userObj = val; },
    SET_ROLES(state, val) { state.roles = val; },
    SET_CONTROLLED_ACTIONS(state, val) { state.controlledActions = val; }
};
const actions = {
    setActingUserId({ commit }, value) {
        commit('SET_ACTING_USER_ID', value);
    },
    setRoles({ commit }, value) { commit('SET_ROLES', value); },
    setControlledActions({ commit }, value) { commit('SET_CONTROLLED_ACTIONS', value); }
};
const namespaced = true;
export default { state, getters, actions, mutations, namespaced };
